<p>view-booking-company-room works!</p>
